/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ToastConfig } from './toastConfig';
import { EmailSentData } from './emailSentData';


/**
 * WebSocket notification for email sent.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface EmailSentNotification { 
    /**
     * Always \'email.sent\'
     */
    readonly type: string;
    data: EmailSentData;
    toast?: ToastConfig | null;
}
export const EmailSentNotification_type_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const EmailSentNotification_data_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const EmailSentNotification_toast_Validators: ValidatorFn[] =
    [ ];


